module.exports = __webpack_public_path__ + "static/img/141.21bd572.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/141.png
// module id = uIHB
// module chunks = 0